var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      [
        _c("SectionHeader", {
          attrs: { title: "Client Information", currentUser: _vm.currentUser },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c(
          "InfoGrid",
          [
            _c("InfoField", {
              attrs: {
                label: "Client Name",
                value: _vm.proejctData.client_name,
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Client Identifier(s)",
                value: _vm.proejctData.client_id,
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Date of Birth",
                value: _vm.formatDate(_vm.proejctData.dob),
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Gender",
                value: _vm.proejctData.gender,
                defaultText: "N/A",
                optional: true,
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Address",
                value: _vm.proejctData.address,
                defaultText: "N/A",
              },
            }),
            _vm.isAdmin
              ? _c("InfoField", {
                  attrs: {
                    label: "Phone Number",
                    value: _vm.proejctData.phone_number,
                    defaultText: "N/A",
                  },
                })
              : _vm._e(),
            _vm.isAdmin
              ? _c("InfoField", {
                  attrs: {
                    label: "Email Address",
                    value: _vm.proejctData.email_address,
                    defaultText: "N/A",
                  },
                })
              : _vm._e(),
            _c("InfoField", {
              attrs: {
                label: "Care Plan Start Date",
                value: _vm.formatDate(_vm.data.care_plan_start_date),
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Care Plan End Date",
                value: _vm.formatDate(_vm.data.care_plan_end_date),
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Care Plan Created By",
                value: _vm.data.care_plan_created_by,
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Care Plan Created Date",
                value: _vm.formatDate(_vm.data.care_plan_created_at),
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Last Updated By",
                value: _vm.data.care_plan_updated_by,
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Last Updated Date",
                value: _vm.formatDate(_vm.data.care_plan_updated_at),
                defaultText: "N/A",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }